import { render, staticRenderFns } from "./waarzijnwenu.vue?vue&type=template&id=6c66dfbf&scoped=true"
import script from "./waarzijnwenu.vue?vue&type=script&lang=js"
export * from "./waarzijnwenu.vue?vue&type=script&lang=js"
import style0 from "./waarzijnwenu.vue?vue&type=style&index=0&id=6c66dfbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66dfbf",
  null
  
)

export default component.exports